import React, { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import './PermissionModal.scss';

interface PermissionModalProps {
    message: string;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    title?: string;
}

const PermissionModal: React.FC<PermissionModalProps> = ({
    message,
    open,
    setOpen,
    title = 'Action not allowed',
}) => {
    const cancelButtonRef = useRef(null);
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as='div' className='relative z-10' initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-300'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='ease-in duration-200'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <div className='fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity' />
                </Transition.Child>
                <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
                    <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-300'
                            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                            enterTo='opacity-100 translate-y-0 sm:scale-100'
                            leave='ease-in duration-200'
                            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                        >
                            <Dialog.Panel className='relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full modal modal-bg permission-modal'>
                                <div className="absolute right-0 top-0 pr-0 pt-4">
                                    <button
                                        type="button"
                                        className="close-button rounded-md text-gray-400 hover:text-white focus:outline-none"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="sr-only">Close</span>
                                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <div className='text-center'>
                                        <div className='permission-icon'>
                                            <div className="orange-circle-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                        <Dialog.Title as='h3' className='text-base font-semibold leading-6 text-white modal-title mt-4'>
                                            {title}
                                        </Dialog.Title>
                                        <div className='mt-2'>
                                            <p className='modal-text'>{message}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='modal-btns'>
                                    <hr className='partition' />
                                    <div className='mt-2 px-6 flex justify-center'>
                                        <button
                                            type='button'
                                            analytics-id='modal-ok-btn'
                                            className='btn-confirm'
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                            ref={cancelButtonRef}
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};
export default PermissionModal;